"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPayoutTypeToString = transformPayoutTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPayoutTypeToString(type) {
    switch (type) {
        case legacy_enums_1.PayoutType.Mangopay:
            return "Mangopay";
        case legacy_enums_1.PayoutType.Paypal:
            return "Paypal";
        case legacy_enums_1.PayoutType.Cash:
            return "cash";
        case legacy_enums_1.PayoutType.BankTransaction:
            return "bank transaction";
        case legacy_enums_1.PayoutType.Hyperwallet:
            return "Hyperwallet";
        case legacy_enums_1.PayoutType.Stripe:
            return "Stripe";
        case legacy_enums_1.PayoutType.Other:
            return "other";
        default:
            return "unknown status";
    }
}
//# sourceMappingURL=transformPayoutTypeToString.js.map